@if(mode==="read"){
<div class="ppl-mt8">
    <h2 tabindex="-1" pplAutoFocusHeader>Associations</h2>
</div>
@if(flow === 'participantEnrollment'){
<ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="false" [data]="participantAssociations"
    [disableSelection]="true" [cols]="participantCols" [gridTitle]="false" [pagination]="false" [loadPage]="true"
    [actionButtons]="null">
</ppl-list-table>
}
@if(flow === 'providerEnrollment'){
@if(isMobileView){
<div class="card-layout pl-0 pr-3">
    <div class="card" *ngFor="let association of associations">
        <div class="card-item mt-2">
            Name : {{ association.participantFirstName }} {{ association.participantLastName }}
        </div>
        <div class="card-item">
            PPL ID : {{association.participantPplId}}
        </div>
        <div class="card-item">
            Association Type : {{association.providerTypeLabel}}
        </div>
        <div class="card-item">
            Start Date : {{association.associationStartDate}}
        </div>
        @if(association.associationEndDate) {
        <div>
            End Date : {{association.associationEndDate}}
        </div>
        }
    </div>
</div>
} @else {
<ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="false" [data]="associations"
    [disableSelection]="true" [cols]="associationCols" [gridTitle]="false" [pagination]="false" [loadPage]="true"
    [actionButtons]="null"></ppl-list-table>
}
}
}
@else{
<div class="ppl-mt8">
    <h2 tabindex="-1" pplAutoFocusHeader>Add Associations</h2>
</div>
@if(isStepMandatory){
<div class="ppl-form-item">
    <p class="info-box">
        <i class="fa fa-info-circle" aria-hidden="true"></i> <span>Please add at least one association</span>
    </p>
</div>
}
<div class="ppl-mt16 btn-group" style="display: flex; gap: 8px;">
    <!-- <button nzType="primary" class="ppl-mr16 btn-hide" nz-button [nzSize]="'small'" (click)="expandAll()">Expand
      All</button>
    <button nzType="primary" nz-button class="btn-hide" [nzSize]="'small'" (click)="hideAll()">Hide All</button> -->
    <ppl-button label="Expand All" icon="fa fa-expand" [customClass]="'alt-button'" [iconPosition]="'right'"
        (click)="expandAll()"></ppl-button>
    <ppl-button label="Collapse All" icon="fa fa-compress" [customClass]="'alt-button'" [iconPosition]="'right'"
        (click)="hideAll()"></ppl-button>
</div>
<div>
    <div class="sr-only" aria-live="assertive" aria-atomic="true" #a1yStatus></div>
    <form nz-form [formGroup]="newContactForm" class="ppl-p0">
        <nz-collapse [nzExpandIconPosition]="'end'">
            @if(isAttrAvailable('newEmployer')){
            <nz-collapse-panel [nzHeader]="'Employer Details'" [nzActive]="isPanelActive('1')" (nzActiveChange)="onPanelActiveChange('1', $event)"
                (nzClick)="togglePanel('1')">
                @if (getProviderData('EMP').length >0) {
                    <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="true"
                        [data]="getProviderData('EMP')" [disableSelection]="true" [cols]="getProviderColumns('EMP')"
                        [gridTitle]="false" [pagination]="false" [loadPage]="true" [actionButtons]="actions" (gridAction)="action($event)"
                        [attr.id]="'assoc-panel-1-content'" role="region" [attr.aria-labelledby]="'assoc-panel-1-header'" [hidden]="!isPanelActive('1')" [attr.aria-hidden]="!isPanelActive('1')" [attr.inert]="!isPanelActive('1') ? '' : null">
                    </ppl-list-table>
                }
                @if(getProviderData('EMP').length < 1) { <div
                    class="actions-container" [attr.id]="'assoc-panel-1-actions'" role="region" [attr.aria-labelledby]="'assoc-panel-1-header'" [hidden]="!isPanelActive('1')" [attr.aria-hidden]="!isPanelActive('1')" [attr.inert]="!isPanelActive('1') ? '' : null">
                        <ppl-button label="Add Employer" icon="fa fa-plus" [customClass]="'ghost-button'"
                            [iconPosition]="'left'" (click)="addAssociation('employer')" [attr.aria-label]="'Add Employer in Employer Details section'"></ppl-button>
                    </div>
}
</nz-collapse-panel>
}
@if(isAttrAvailable('newAuthRep')){
<nz-collapse-panel [nzHeader]="'Designated Representative Details'" [nzActive]="isPanelActive('2')" (nzActiveChange)="onPanelActiveChange('2', $event)"
    (nzClick)="togglePanel('2')">
    @if (getProviderData('AR').length >0) {
    @if(isMobileView){
    <div class="card-layout pl-0 pr-0 m-0" [attr.id]="'assoc-panel-2-content'" role="region" [attr.aria-labelledby]="'assoc-panel-2-header'" [hidden]="!isPanelActive('2')" [attr.aria-hidden]="!isPanelActive('2')" [attr.inert]="!isPanelActive('2') ? '' : null">
        <div class="card mt-2" *ngFor="let association of getProviderData('AR')">
            <div class="card-item">
                <nz-row>
                    <div nz-col nzSpan="12" [nzXs]="24">
                        <nz-row>
                            <strong nz-col nzSpan="12" [nzXs]="9">Tracking Number </strong>
                            <span nz-col nzSpan="12" [nzXs]="15" class="pl-1">{{association.trackingNumber}}</span>
                        </nz-row>
                    </div>
                </nz-row>
            </div>

            <div class="card-item">
                <nz-row>
                    <div nz-col nzSpan="12" [nzXs]="24">
                        <nz-row>
                            <strong nz-col nzSpan="12" [nzXs]="9">PPL ID </strong>
                            <span nz-col nzSpan="12" [nzXs]="15" class="pl-1">{{association.pplProviderId}}</span>
                        </nz-row>
                    </div>
                </nz-row>
            </div>

            <div class="card-item">
                <nz-row>
                    <div nz-col nzSpan="12" [nzXs]="24">
                        <nz-row>
                            <strong nz-col nzSpan="12" [nzXs]="9">Name </strong>
                            <span nz-col nzSpan="12" [nzXs]="15" class="pl-1">{{association.providerFirstName}}
                                {{association.providerLastName}}</span>
                        </nz-row>
                    </div>
                </nz-row>
            </div>

            <div class="card-item">
                <nz-row>
                    <div nz-col nzSpan="12" [nzXs]="24">
                        <nz-row>
                            <strong nz-col nzSpan="12" [nzXs]="9">Relationship To Consumer </strong>
                            <span nz-col nzSpan="12" [nzXs]="15"
                                class="pl-1">{{association.relationToParticipant}}</span>
                        </nz-row>
                    </div>
                </nz-row>
            </div>

            <div class="card-item">
                <nz-row>
                    <div nz-col nzSpan="12" [nzXs]="24">
                        <nz-row>
                            <strong nz-col nzSpan="12" [nzXs]="9">Email </strong>
                            <span nz-col nzSpan="12" [nzXs]="15" class="pl-1">{{association.email}}</span>
                        </nz-row>
                    </div>
                </nz-row>
            </div>

            <div class="card-item">
                <nz-row>
                    <div nz-col nzSpan="12" [nzXs]="24">
                        <nz-row>
                            <strong nz-col nzSpan="12" [nzXs]="9">Contact Number </strong>
                            <span nz-col nzSpan="12" [nzXs]="15" class="pl-1">{{association.mobile}}</span>
                        </nz-row>
                    </div>
                </nz-row>
            </div>

            <div class="card-item">
                <nz-row>
                    <div nz-col nzSpan="12" [nzXs]="24">
                        <nz-row>
                            <strong nz-col nzSpan="12" [nzXs]="9">Association Status </strong>
                            <span nz-col nzSpan="12" [nzXs]="15" class="pl-1">{{association.associationStatus}}</span>
                        </nz-row>
                    </div>
                </nz-row>
            </div>

            <div class="card-item">
                <nz-row>
                    <div nz-col nzSpan="12" [nzXs]="24">
                        <nz-row>
                            <strong nz-col nzSpan="12" [nzXs]="9">Start Date </strong>
                            <span nz-col nzSpan="12" [nzXs]="15"
                                class="pl-1">{{association.associationStartDate}}</span>
                        </nz-row>
                    </div>
                </nz-row>
            </div>

            @if(association.associationEndDate) {
            <div class="card-item">
                <nz-row>
                    <div nz-col nzSpan="12" [nzXs]="24">
                        <nz-row>
                            <strong nz-col nzSpan="12" [nzXs]="9">End Date </strong>
                            <span nz-col nzSpan="12" [nzXs]="15" class="pl-1">{{association.associationEndDate}}</span>
                        </nz-row>
                    </div>
                </nz-row>
            </div>
            }
        </div>
    </div>
    } @else {
    <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="true" [data]="getProviderData('AR')"
        [disableSelection]="true" [cols]="getProviderColumns('AR')" [gridTitle]="false" [pagination]="false"
        [loadPage]="true" [actionButtons]="actions" (gridAction)="action($event)" [attr.id]="'assoc-panel-2-content'" role="region" [attr.aria-labelledby]="'assoc-panel-2-header'" [hidden]="!isPanelActive('2')" [attr.aria-hidden]="!isPanelActive('2')" [attr.inert]="!isPanelActive('2') ? '' : null">
    </ppl-list-table>
    }
}
    @if(!isConsumerAbove18 && !getDRCount()) {
     <div class="info-note">
        <p class="font-weight-600">Note: Designated Representative Required</p>
        <p>Because you are under 18 years old, you need to choose a designated representative who is 18 or older to help
            with your CDPAP responsibilities. Please be sure to add the information for the person you want to help you. You
            have to add a designated representative to participate in CDPAP.</p>
    </div>
    }
    <div class="actions-container" [attr.id]="'assoc-panel-2-actions'" role="region" [attr.aria-labelledby]="'assoc-panel-2-header'" [hidden]="!isPanelActive('2')" [attr.aria-hidden]="!isPanelActive('2')" [attr.inert]="!isPanelActive('2') ? '' : null">
        <ppl-button label="Add Designated Representative" icon="fa fa-plus" [customClass]="'ghost-button'"
            [iconPosition]="'left'" (click)="addAssociation('authRepresentative')" [attr.aria-label]="'Add Designated Representative in Designated Representative Details section'"></ppl-button>
    </div>

</nz-collapse-panel>
}
@if(isAttrAvailable('newProvider')){
<nz-collapse-panel [nzHeader]="'Personal Assistant Details'" [nzActive]="isPanelActive('3')" (nzActiveChange)="onPanelActiveChange('3', $event)"
    (nzClick)="togglePanel('3')">
    @if (getProviderData('IR').length >0) {
    @if(isMobileView){
    <div class="card-layout pl-0 pr-0 m-0" [attr.id]="'assoc-panel-3-content'" role="region" [attr.aria-labelledby]="'assoc-panel-3-header'" [hidden]="!isPanelActive('3')" [attr.aria-hidden]="!isPanelActive('3')" [attr.inert]="!isPanelActive('3') ? '' : null">
        <div class="card mt-2" *ngFor="let association of getProviderData('IR')">
            <div class="card-item">
                <nz-row>
                    <div nz-col nzSpan="12" [nzXs]="24">
                        <nz-row>
                            <strong nz-col nzSpan="12" [nzXs]="9">Tracking Number </strong>
                            <span nz-col nzSpan="12" [nzXs]="15" class="pl-1">{{association.trackingNumber}}</span>
                        </nz-row>
                    </div>
                </nz-row>
            </div>

            <div class="card-item">
                <nz-row>
                    <div nz-col nzSpan="12" [nzXs]="24">
                        <nz-row>
                            <strong nz-col nzSpan="12" [nzXs]="9">PPL ID </strong>
                            <span nz-col nzSpan="12" [nzXs]="15" class="pl-1">{{association.pplProviderId}}</span>
                        </nz-row>
                    </div>
                </nz-row>
            </div>

            <div class="card-item">
                <nz-row>
                    <div nz-col nzSpan="12" [nzXs]="24">
                        <nz-row>
                            <strong nz-col nzSpan="12" [nzXs]="9">Name </strong>
                            <span nz-col nzSpan="12" [nzXs]="15" class="pl-1">{{association.providerFirstName}}
                                {{association.providerLastName}}</span>
                        </nz-row>
                    </div>
                </nz-row>
            </div>

            <div class="card-item">
                <nz-row>
                    <div nz-col nzSpan="12" [nzXs]="24">
                        <nz-row>
                            <strong nz-col nzSpan="12" [nzXs]="9">Relationship To Consumer </strong>
                            <span nz-col nzSpan="12" [nzXs]="15"
                                class="pl-1">{{association.relationToParticipant}}</span>
                        </nz-row>
                    </div>
                </nz-row>
            </div>

            <div class="card-item">
                <nz-row>
                    <div nz-col nzSpan="12" [nzXs]="24">
                        <nz-row>
                            <strong nz-col nzSpan="12" [nzXs]="9">Email </strong>
                            <span nz-col nzSpan="12" [nzXs]="15" class="pl-1">{{association.email}}</span>
                        </nz-row>
                    </div>
                </nz-row>
            </div>

            <div class="card-item">
                <nz-row>
                    <div nz-col nzSpan="12" [nzXs]="24">
                        <nz-row>
                            <strong nz-col nzSpan="12" [nzXs]="9">Contact Number </strong>
                            <span nz-col nzSpan="12" [nzXs]="15" class="pl-1">{{association.mobile}}</span>
                        </nz-row>
                    </div>
                </nz-row>
            </div>

            <div class="card-item">
                <nz-row>
                    <div nz-col nzSpan="12" [nzXs]="24">
                        <nz-row>
                            <strong nz-col nzSpan="12" [nzXs]="9">Association Status </strong>
                            <span nz-col nzSpan="12" [nzXs]="15" class="pl-1">{{association.associationStatus}}</span>
                        </nz-row>
                    </div>
                </nz-row>
            </div>

            <div class="card-item">
                <nz-row>
                    <div nz-col nzSpan="12" [nzXs]="24">
                        <nz-row>
                            <strong nz-col nzSpan="12" [nzXs]="9">Start Date </strong>
                            <span nz-col nzSpan="12" [nzXs]="15"
                                class="pl-1">{{association.associationStartDate}}</span>
                        </nz-row>
                    </div>
                </nz-row>
            </div>

            @if(association.associationEndDate) {
            <div class="card-item">
                <nz-row>
                    <div nz-col nzSpan="12" [nzXs]="24">
                        <nz-row>
                            <strong nz-col nzSpan="12" [nzXs]="9">End Date </strong>
                            <span nz-col nzSpan="12" [nzXs]="15" class="pl-1">{{association.associationEndDate}}</span>
                        </nz-row>
                    </div>
                </nz-row>
            </div>
            }
        </div>
    </div>
    } @else {
    <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="true" [data]="getProviderData('IR')"
        [disableSelection]="true" [cols]="getProviderColumns('IR')" [gridTitle]="false" [pagination]="false"
        [loadPage]="true" [actionButtons]="actions" (gridAction)="action($event)" [attr.id]="'assoc-panel-3-content'" role="region" [attr.aria-labelledby]="'assoc-panel-3-header'" [hidden]="!isPanelActive('3')" [attr.aria-hidden]="!isPanelActive('3')" [attr.inert]="!isPanelActive('3') ? '' : null">
    </ppl-list-table>
    }
    }
    <div class="actions-container" [attr.id]="'assoc-panel-3-actions'" role="region" [attr.aria-labelledby]="'assoc-panel-3-header'" [hidden]="!isPanelActive('3')" [attr.aria-hidden]="!isPanelActive('3')" [attr.inert]="!isPanelActive('3') ? '' : null">
        @if(!isMobileView) {
        <ppl-button label="Search" icon="fa fa-magnifying-glass" [customClass]="'ghost-button'" [iconPosition]="'left'"
            (click)="addAssociation('provider', editMode.Search)" [attr.aria-label]="'Search Personal Assistant in Personal Assistant Details section'"></ppl-button>
        }
        <ppl-button label="Add Personal Assistant" icon="fa fa-plus" [customClass]="'ghost-button'"
            [iconPosition]="'left'" (click)="addAssociation('provider', editMode.Edit)" [attr.aria-label]="'Add Personal Assistant in Personal Assistant Details section'"></ppl-button>
    </div>
</nz-collapse-panel>
}
@if(isAttrAvailable('newVendor')){
<nz-collapse-panel [nzHeader]="'Vendor Details'" [nzActive]="isPanelActive('4')" (nzActiveChange)="onPanelActiveChange('4', $event)" (nzClick)="togglePanel('4')">
    @if (getProviderData('Vendor').length >0) {
    <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="true"
        [data]="getProviderData('Vendor')" [disableSelection]="true" [cols]="getProviderColumns('Vendor')"
        [gridTitle]="false" [pagination]="false" [loadPage]="true" [actionButtons]="actions" (gridAction)="action($event)" [attr.id]="'assoc-panel-4-content'"
        role="region" [attr.aria-labelledby]="'assoc-panel-4-header'" [hidden]="!isPanelActive('4')" [attr.aria-hidden]="!isPanelActive('4')" [attr.inert]="!isPanelActive('4') ? '' : null">
    </ppl-list-table>
    }
    <div class="actions-container" [attr.id]="'assoc-panel-4-actions'" role="region" [attr.aria-labelledby]="'assoc-panel-4-header'" [hidden]="!isPanelActive('4')" [attr.aria-hidden]="!isPanelActive('4')" [attr.inert]="!isPanelActive('4') ? '' : null">
        <ppl-button label="Add Vendor" icon="fa fa-plus" [customClass]="'ghost-button'"
            [iconPosition]="'left'" (click)="addAssociation('vendor')" [attr.aria-label]="'Add Vendor in Vendor Details section'"></ppl-button>
    </div>
</nz-collapse-panel>
}
@if(isAttrAvailable('newContractor')){
<nz-collapse-panel [nzHeader]="'Independent Contractor Details'" [nzActive]="isPanelActive('5')" (nzActiveChange)="onPanelActiveChange('5', $event)"
    (nzClick)="togglePanel('5')">
    @if (getProviderData('IC').length >0) {
    <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="true" [data]="getProviderData('IC')"
        [disableSelection]="true" [cols]="getProviderColumns('IC')" [gridTitle]="false" [pagination]="false"
        [loadPage]="true" [actionButtons]="actions" (gridAction)="action($event)" [attr.id]="'assoc-panel-5-content'" role="region" [attr.aria-labelledby]="'assoc-panel-5-header'" [hidden]="!isPanelActive('5')" [attr.aria-hidden]="!isPanelActive('5')" [attr.inert]="!isPanelActive('5') ? '' : null">
    </ppl-list-table>
    }
    <div class="actions-container" [attr.id]="'assoc-panel-5-actions'" role="region" [attr.aria-labelledby]="'assoc-panel-5-header'" [hidden]="!isPanelActive('5')" [attr.aria-hidden]="!isPanelActive('5')" [attr.inert]="!isPanelActive('5') ? '' : null">
        <ppl-button label="Add Contractor" icon="fa fa-plus" [customClass]="'ghost-button'"
            [iconPosition]="'left'" (click)="addAssociation('contractor')" [attr.aria-label]="'Add Contractor in Independent Contractor Details section'"></ppl-button>
    </div>
</nz-collapse-panel>
}
@if(isAttrAvailable('newLegalGuardian')){
<nz-collapse-panel [nzHeader]="'Legal Guardian Details'" [nzActive]="isPanelActive('6')" (nzActiveChange)="onPanelActiveChange('6', $event)" (nzClick)="togglePanel('6')">
    @if (getProviderData('LG').length >0) {
    @if(isMobileView){
    <div class="card-layout pl-0 pr-0 m-0" [attr.id]="'assoc-panel-6-content'" role="region" [attr.aria-labelledby]="'assoc-panel-6-header'" [hidden]="!isPanelActive('6')" [attr.aria-hidden]="!isPanelActive('6')" [attr.inert]="!isPanelActive('6') ? '' : null">
        <div class="card mt-2" *ngFor="let association of getProviderData('LG')">
            <div class="card-item">
                <nz-row>
                    <div nz-col nzSpan="12" [nzXs]="24">
                        <nz-row>
                            <strong nz-col nzSpan="12" [nzXs]="9">Tracking Number </strong>
                            <span nz-col nzSpan="12" [nzXs]="15" class="pl-1">{{association.trackingNumber}}</span>
                        </nz-row>
                    </div>
                </nz-row>
            </div>

            <div class="card-item">
                <nz-row>
                    <div nz-col nzSpan="12" [nzXs]="24">
                        <nz-row>
                            <strong nz-col nzSpan="12" [nzXs]="9">PPL ID </strong>
                            <span nz-col nzSpan="12" [nzXs]="15" class="pl-1">{{association.pplProviderId}}</span>
                        </nz-row>
                    </div>
                </nz-row>
            </div>

            <div class="card-item">
                <nz-row>
                    <div nz-col nzSpan="12" [nzXs]="24">
                        <nz-row>
                            <strong nz-col nzSpan="12" [nzXs]="9">Name </strong>
                            <span nz-col nzSpan="12" [nzXs]="15" class="pl-1">{{association.providerFirstName}}
                                {{association.providerLastName}}</span>
                        </nz-row>
                    </div>
                </nz-row>
            </div>

            <div class="card-item">
                <nz-row>
                    <div nz-col nzSpan="12" [nzXs]="24">
                        <nz-row>
                            <strong nz-col nzSpan="12" [nzXs]="9">Email </strong>
                            <span nz-col nzSpan="12" [nzXs]="15" class="pl-1">{{association.email}}</span>
                        </nz-row>
                    </div>
                </nz-row>
            </div>

            <div class="card-item">
                <nz-row>
                    <div nz-col nzSpan="12" [nzXs]="24">
                        <nz-row>
                            <strong nz-col nzSpan="12" [nzXs]="9">Contact Number </strong>
                            <span nz-col nzSpan="12" [nzXs]="15" class="pl-1">{{association.mobile}}</span>
                        </nz-row>
                    </div>
                </nz-row>
            </div>

            <div class="card-item">
                <nz-row>
                    <div nz-col nzSpan="12" [nzXs]="24">
                        <nz-row>
                            <strong nz-col nzSpan="12" [nzXs]="9">Association Status </strong>
                            <span nz-col nzSpan="12" [nzXs]="15" class="pl-1">{{association.associationStatus}}</span>
                        </nz-row>
                    </div>
                </nz-row>
            </div>

            <div class="card-item">
                <nz-row>
                    <div nz-col nzSpan="12" [nzXs]="24">
                        <nz-row>
                            <strong nz-col nzSpan="12" [nzXs]="9">Start Date </strong>
                            <span nz-col nzSpan="12" [nzXs]="15"
                                class="pl-1">{{association.associationStartDate}}</span>
                        </nz-row>
                    </div>
                </nz-row>
            </div>

            @if(association.associationEndDate) {
            <div class="card-item">
                <nz-row>
                    <div nz-col nzSpan="12" [nzXs]="24">
                        <nz-row>
                            <strong nz-col nzSpan="12" [nzXs]="9">End Date </strong>
                            <span nz-col nzSpan="12" [nzXs]="15" class="pl-1">{{association.associationEndDate}}</span>
                        </nz-row>
                    </div>
                </nz-row>
            </div>
            }
        </div>
    </div>
    } @else {
    <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="true" [data]="getProviderData('LG')"
        [disableSelection]="true" [cols]="getProviderColumns('LG')" [gridTitle]="false" [pagination]="false"
        [loadPage]="true" [actionButtons]="actions" (gridAction)="action($event)" [attr.id]="'assoc-panel-6-content'" role="region" [attr.aria-labelledby]="'assoc-panel-6-header'" [hidden]="!isPanelActive('6')" [attr.aria-hidden]="!isPanelActive('6')" [attr.inert]="!isPanelActive('6') ? '' : null">
    </ppl-list-table>
    }
}
    <div class="actions-container" [attr.id]="'assoc-panel-6-actions'" role="region" [attr.aria-labelledby]="'assoc-panel-6-header'" [hidden]="!isPanelActive('6')" [attr.aria-hidden]="!isPanelActive('6')" [attr.inert]="!isPanelActive('6') ? '' : null">
        <ppl-button label="Add Legal Guardian" icon="fa fa-plus" [customClass]="'ghost-button'" [iconPosition]="'left'"
            (click)="addAssociation('legalGuardian')" [attr.aria-label]="'Add Legal Guardian in Legal Guardian Details section'"></ppl-button>
    </div>
</nz-collapse-panel>
}
@if(isAttrAvailable('newPOA')){
<nz-collapse-panel [nzHeader]="'POA Details'" [nzActive]="isPanelActive('7')" (nzActiveChange)="onPanelActiveChange('7', $event)"(nzClick)="togglePanel('7')">
    @if (getProviderData('POA').length >0) {
    @if(isMobileView){
    <div class="card-layout pl-0 pr-0 m-0" [attr.id]="'assoc-panel-7-content'" role="region" [attr.aria-labelledby]="'assoc-panel-7-header'" [hidden]="!isPanelActive('7')" [attr.aria-hidden]="!isPanelActive('7')" [attr.inert]="!isPanelActive('7') ? '' : null">
        <div class="card mt-2" *ngFor="let association of getProviderData('POA')">
            <div class="card-item">
                <nz-row>
                    <div nz-col nzSpan="12" [nzXs]="24">
                        <nz-row>
                            <strong nz-col nzSpan="12" [nzXs]="9">Tracking Number </strong>
                            <span nz-col nzSpan="12" [nzXs]="15" class="pl-1">{{association.trackingNumber}}</span>
                        </nz-row>
                    </div>
                </nz-row>
            </div>

            <div class="card-item">
                <nz-row>
                    <div nz-col nzSpan="12" [nzXs]="24">
                        <nz-row>
                            <strong nz-col nzSpan="12" [nzXs]="9">PPL ID </strong>
                            <span nz-col nzSpan="12" [nzXs]="15" class="pl-1">{{association.pplProviderId}}</span>
                        </nz-row>
                    </div>
                </nz-row>
            </div>

            <div class="card-item">
                <nz-row>
                    <div nz-col nzSpan="12" [nzXs]="24">
                        <nz-row>
                            <strong nz-col nzSpan="12" [nzXs]="9">Name </strong>
                            <span nz-col nzSpan="12" [nzXs]="15" class="pl-1">{{association.providerFirstName}}
                                {{association.providerLastName}}</span>
                        </nz-row>
                    </div>
                </nz-row>
            </div>

            <div class="card-item">
                <nz-row>
                    <div nz-col nzSpan="12" [nzXs]="24">
                        <nz-row>
                            <strong nz-col nzSpan="12" [nzXs]="9">Email </strong>
                            <span nz-col nzSpan="12" [nzXs]="15" class="pl-1">{{association.email}}</span>
                        </nz-row>
                    </div>
                </nz-row>
            </div>

            <div class="card-item">
                <nz-row>
                    <div nz-col nzSpan="12" [nzXs]="24">
                        <nz-row>
                            <strong nz-col nzSpan="12" [nzXs]="9">Contact Number </strong>
                            <span nz-col nzSpan="12" [nzXs]="15" class="pl-1">{{association.mobile}}</span>
                        </nz-row>
                    </div>
                </nz-row>
            </div>

            <div class="card-item">
                <nz-row>
                    <div nz-col nzSpan="12" [nzXs]="24">
                        <nz-row>
                            <strong nz-col nzSpan="12" [nzXs]="9">Association Status </strong>
                            <span nz-col nzSpan="12" [nzXs]="15" class="pl-1">{{association.associationStatus}}</span>
                        </nz-row>
                    </div>
                </nz-row>
            </div>

            <div class="card-item">
                <nz-row>
                    <div nz-col nzSpan="12" [nzXs]="24">
                        <nz-row>
                            <strong nz-col nzSpan="12" [nzXs]="9">Start Date </strong>
                            <span nz-col nzSpan="12" [nzXs]="15"
                                class="pl-1">{{association.associationStartDate}}</span>
                        </nz-row>
                    </div>
                </nz-row>
            </div>

            @if(association.associationEndDate) {
            <div class="card-item">
                <nz-row>
                    <div nz-col nzSpan="12" [nzXs]="24">
                        <nz-row>
                            <strong nz-col nzSpan="12" [nzXs]="9">End Date </strong>
                            <span nz-col nzSpan="12" [nzXs]="15" class="pl-1">{{association.associationEndDate}}</span>
                        </nz-row>
                    </div>
                </nz-row>
            </div>
            }
        </div>
    </div>
    } @else {
    <ppl-list-table [disableSort]="true" [disableSearch]="true" [enableActions]="true" [data]="getProviderData('POA')"
        [disableSelection]="true" [cols]="getProviderColumns('POA')" [gridTitle]="false" [pagination]="false"
        [loadPage]="true" [actionButtons]="actions" (gridAction)="action($event)" [attr.id]="'assoc-panel-7-content'" role="region" [attr.aria-labelledby]="'assoc-panel-7-header'" [hidden]="!isPanelActive('7')" [attr.aria-hidden]="!isPanelActive('7')" [attr.inert]="!isPanelActive('7') ? '' : null">
    </ppl-list-table>
    }
}
    <div class="actions-container" [attr.id]="'assoc-panel-7-actions'" role="region" [attr.aria-labelledby]="'assoc-panel-7-header'" [hidden]="!isPanelActive('7')" [attr.aria-hidden]="!isPanelActive('7')" [attr.inert]="!isPanelActive('7') ? '' : null">
        <ppl-button label="Add POA" icon="fa fa-plus" [customClass]="'ghost-button'"
            [iconPosition]="'left'" (click)="addAssociation('poa')" [attr.aria-label]="'Add POA in POA Details section'"></ppl-button>
    </div>
</nz-collapse-panel>
}
</nz-collapse>
</form>
</div>
}

<div class="filter-panel">
    <ng-template #confirmationDialog let-cancel="cancel">
      <p> Are you sure you want to remove this association ?</p>
    </ng-template>
  </div>

  <div class="filter-panel">
    <ng-template #deleteConfirmationDialog let-cancel="cancel">
      <p> Consumers under the age of 18 are required to have at least one Designated Representative. </p>
      <p> Please add a new Designated Representative before removing the existing one. </p>
    </ng-template>
  </div>